<template>
	<div>
		<v-row>
			<v-col
				cols="3"
				lg="2"
			>
				<v-card>
					<v-card-title class="d-flex align-center">
						<v-icon
							icon="$world"
							start
						/>
						<translate>Domain</translate>
					</v-card-title>
					<v-card-text>
						<v-select
							v-model="domainName"
							variant="outlined"
							label="Domain"
							:items="domains"
							item-title="name"
							item-value="name"
						/>
						<v-spacer />
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<translated-segment-list
					:domain-name="domainName"
					:segments-with-translations="segmentsWithTranslations"
					@update:segments-with-translations="refreshRoutes"
				/>
			</v-col>
			<v-col>
				<translated-route-list
					:domain-name="domainName"
					:routes-with-translations="routesWithTranslations"
				/>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import axios from 'axios';
import {
	compact, flatten, uniq,
} from 'lodash';
import RouteTranslator from '../../../../util/route-translator';
import TranslatedRouteList from '../../../molecules/TranslatedRouteList.vue';
import TranslatedSegmentList from '../../../molecules/TranslatedSegmentList.vue';

export default {
	name: 'RouteTranslations',
	components: {
		TranslatedSegmentList,
		TranslatedRouteList
	},
	data () {
		return {
			domainName: 'NL',
			domains: [],
			routes: [],
			routesWithTranslations: [],
			routeTranslator: null,
			segments: [],
			segmentsWithTranslations: [],
		};
	},
	watch: {
		domainName: function () {
			this.translateRoutes();
			this.translateSegments();
		},
		routes: function () {
			this.translateRoutes();
			this.segments = compact(uniq(flatten(this.routes.map((route) => route.split('?')[0].split('/')))));
		},
		segments: function () {
			this.translateSegments();
		}
	},
	created () {
		this.fetchUserFacingFileTreeRoutes();
		this.fetchDomains();
	},
	methods: {

		/**
		 *
		 */
		async refreshRoutes () {
			await this.getRouteTranslator(false);
			this.translateRoutes();
			this.translateSegments();
		},

		/**
		 * @returns {void}
		 */
		fetchUserFacingFileTreeRoutes () {
			axios.get('/api/v0/routes/userfacing')
				.then(({
					data: routes
				}) => {
					this.routes = routes;
				});
		},

		/**
		 * @returns {void}
		 */
		fetchDomains () {
			axios.get('/api/v0/domains')
				.then(({
					data: domains
				}) => {
					this.domains = domains;
				});
		},

		/**
		 * @param {boolean} allowCache
		 * @returns {Promise} Route translator promise
		 */
		getRouteTranslator (allowCache = true) {
			return new Promise((resolve, reject) => {
				if (this.routeTranslator && this.routeTranslator.isForDomain(this.domainName) && allowCache) {
					resolve(this.routeTranslator);
				} else {
					RouteTranslator.createForDomain(this.domainName, allowCache)
						.then((routeTranslator) => {
							this.routeTranslator = routeTranslator;
							resolve(this.routeTranslator);
						})
						.catch(reject);
				}
			});
		},

		/**
		 * Translate the routes and set the routesWithTranslations variable
		 *
		 * @returns {void}
		 */
		translateRoutes () {
			this.getRouteTranslator()
				.then((routeTranslator) => {
					this.routesWithTranslations = routeTranslator.translateRoutes(this.routes);
				});
		},

		/**
		 * @returns {void}
		 */
		translateSegments () {
			this.getRouteTranslator()
				.then((routeTranslator) => {
					this.segmentsWithTranslations = this.segments.map((segment) => {
						return {
							segment: segment,
							translation: routeTranslator.translationExists(segment) ? routeTranslator.translateSegment(segment) : '',
						};
					});
				});
		}
	}
};
</script>

<style scoped>

</style>
